import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { Termostatstyring } from '../../../../../utils/registerEnums';
import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { AboutFormControlProps } from '../../types';

const KaminField: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();

  return (
    <Controller
      name="oppvarming.oppvarmingBioenergi.kamin.selected"
      control={control}
      render={({ field: { value, onChange }, fieldState }) => (
        <CollapseCheckbox
          labelKey={'register.tekniskUtstyr.bioKamin.label'}
          checked={!!value}
          onChange={(checked) => {
            onChange(checked);

            const newValue = checked ? { termostatstyring: Termostatstyring.Ukjent } : undefined;

            setValue('oppvarming.oppvarmingBioenergi.kamin.value', newValue);
          }}
          error={!!fieldState.error}
        >
          <Controller
            name="oppvarming.oppvarmingBioenergi.kamin.value"
            control={control}
            render={({ field: { value, onChange }, fieldState }) => (
              <TermostatstyringRadio
                value={value?.termostatstyring}
                labelKey="register.termostatstyring.kamin.label"
                informationKey="register.termostatstyring.kamin.information"
                error={fieldState.error}
                onChange={(val) =>
                  onChange({
                    termostatstyring: val as Termostatstyring
                  })
                }
              />
            )}
          />
        </CollapseCheckbox>
      )}
    />
  );
};

export default KaminField;
